import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

// Inject GetTerms CMP scripts at the very top of the <head>
const injectCmp = () => {
  if (document.getElementById('getterms-cmp-preload')) return;
  const preload = document.createElement('link');
  preload.id = 'getterms-cmp-preload';
  preload.rel = 'preload';
  preload.href = 'https://gettermscmp.com/cookie-consent/blocker/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';
  preload.as = 'script';
  const script1 = document.createElement('script');
  script1.type = 'text/javascript';
  script1.src = 'https://gettermscmp.com/cookie-consent/blocker/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';
  const script2 = document.createElement('script');
  script2.type = 'text/javascript';
  script2.async = true;
  script2.src = 'https://gettermscmp.com/cookie-consent/widget/c2ebea30-4b5c-496c-8778-ae76249b52ad/cust?auto=true';

  // Prepend in reverse order so they end up in the correct order at the top
  document.head.prepend(script2);
  document.head.prepend(script1);
  document.head.prepend(preload);
};
injectCmp();

// Explicitly tell crawlers this site may be indexed and followed.
const ensureRobotsMeta = () => {
  if (document.querySelector('meta[name="robots"]')) return;
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'index, follow';
  document.head.appendChild(meta);
};
ensureRobotsMeta();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<BrowserRouter data-id="element-326" data-mp="1jmeondfdw85p">
      <App data-id="element-327" data-mp="1jllncrz72auy" />
    </BrowserRouter>);
}